import { gql } from '@apollo/client';

export default gql`
  mutation CreateProductClassMutation($productClass: ProductClassInput!) {
    createProductClass(input: { productClass: $productClass }) {
      productClass {
        id
      }
    }
  }
`;
